'use client';

import { createPortal } from 'react-dom';
import useIsHydrated from '../../../hooks/use-is-hydrated';

// This element is present on all pages and is used as an explicit target
// for any portals that need to be rendered to the body, i.e. a modal.
const GLOBAL_MODAL_ROOT_SELECTOR = '#modal-root';

interface PortalProps {
	children: React.ReactNode;
	selector?: string;
}

export default function ClientPortal({
	children,
	selector = GLOBAL_MODAL_ROOT_SELECTOR,
}: PortalProps) {
	const isHydrated = useIsHydrated();

	if (!isHydrated) return null;

	const target = document.querySelector(selector);
	return target ? createPortal(children, target) : null;
}
